import PropTypes from 'prop-types';
import DeliveryOptionSection from '../DeliveryOptionSection/DeliveryOptionSection';
import GenericSection from '../GenericSection/GenericSection';

export default function CollectionOptionsSectionWrapper(props) {
  return (
    <div data-test="CollectionOptionSectionWrapper">
      <GenericSection
        step={props.step}
        isStepActive={props.isStepActive}
        id="CollectionOptionsSection__heading"
        headerKey="checkout.collection.section.heading.text"
      >
        <DeliveryOptionSection isStepActive={props.isStepActive} />
      </GenericSection>
    </div>
  );
}

CollectionOptionsSectionWrapper.propTypes = ({
  step: PropTypes.number.isRequired,
  isStepActive: PropTypes.bool.isRequired,
});
